import React, { useEffect, useState } from 'react'
import PersonLine from '../personLine/personLine'
import styles from './personsPage.module.css'
import Button from '../button/button'
import fetchPersonsShort from '../../api/fetchPersonsShort'
import fetchAllPersonStats from "../../api/fetchAllPersonsStats";
import Header from "../header/header";
interface PersonShort {
	id: number
	first_name: string
	last_name: string
	nick_name: string
	photo: string
	number: number
	club_name: string
	club_logo: string
	role: string
	type: string
	gender: string
}
interface PersonStats {
	person_id: number;
	person_goals: number;
	person_matches: number;
	person_yellow_cards: number;
	person_red_cards: number;
}

const PersonsPage: React.FC = () => {
	const [filter, setFilter] = useState<string | null>(null)
	const [personsShort, setPersonsShort] = useState<PersonShort[]>([])
	const [personsStats, setPersonsStats] = useState<PersonStats[]>([])

	const getPersonsShort = async () => {
		try {
			const data = await fetchPersonsShort()
			setPersonsShort(data)
		} catch (error) {
			console.error('Error fetching short persons data:', error)
		}
	}

	const getPersonsAllStats = async () => {
		try {
			const data = await fetchAllPersonStats()
			setPersonsStats(data)
			console.log(data)
		} catch (error) {
			console.error ('Error fetching persons stats data:', error)
		}
	}

	useEffect(() => {
		getPersonsShort()
		getPersonsAllStats()
	}, [])

	const handleFilterChange = (newFilter: string | null) => {
		setFilter(newFilter)
	}

	const filteredPersonsShort = filter
		? personsShort.filter((person) => {
			if (filter === 'Staff') {
				return person.type === 'Staff'
			}
			return person.role === filter
		})
		: personsShort

	return (
		<>
			<Header title={'Persons'}/>
			<main>
				<div className={styles.persons_container}>
					<h1>Persons</h1>
					<div className={styles.button_container}>
						<Button
							text='All'
							active={filter === null}
							onClick={() => handleFilterChange(null)}
						/>
						<Button
							text='Defenders'
							active={filter === 'Defender'}
							onClick={() => handleFilterChange('Defender')}
						/>
						<Button
							text='Midfielders'
							active={filter === 'Midfielder'}
							onClick={() => handleFilterChange('Midfielder')}
						/>
						<Button
							text='Forwards'
							active={filter === 'Forward'}
							onClick={() => handleFilterChange('Forward')}
						/>
						<Button
							text='Staff'
							active={filter === 'Staff'}
							onClick={() => handleFilterChange('Staff')}
						/>
					</div>
					<table className={styles.person_table}>
						<tr>
							<th className={styles.th_text_left}>
								<h4>Игрок</h4>
							</th>
							<th>
							</th>
							<th>
								<h4>Клуб</h4>
							</th>

							<th>
								<h4>№</h4>
							</th>
							<th>
								<span className={styles.person_table_th}><h4>Амплуа</h4></span>
								<span className={styles.person_table_th_hidden}><h4>А</h4></span>
							</th>
							<th>
								<span className={styles.person_table_th}><h4>Матчи</h4></span>
								<span className={styles.person_table_th_hidden}><h4>М</h4></span>
							</th>
							<th>
						<span className={styles.person_table_th}>
							<h4>Голы</h4></span>
								<span className={styles.person_table_th_hidden}>
							<img src={'http://pitchinvasion.ru/files/icons/goal.svg'} alt={'Goals'}/>
						</span>
							</th>
							<th>
								<span className={styles.person_table_th}><h4>Желтые карточки</h4></span>
								<span className={styles.person_table_th_hidden}>
							<img src={'http://pitchinvasion.ru/files/icons/yellow_card.svg'} alt={'Yellow cards'}/>
						</span>
							</th>
							<th>
								<span className={styles.person_table_th}><h4>Красные карточки</h4></span>
								<span className={styles.person_table_th_hidden}>
							<img src={'http://pitchinvasion.ru/files/icons/red_card.svg'} alt={'Red cards'}/>
						</span>
							</th>
						</tr>
						{filteredPersonsShort.map((person) => {
							const personStats = personsStats.find((stats) => stats.person_id === person.id);
							console.log(personStats)
							return <PersonLine key={person.id.toString()} person={person} personStats={personStats} />;
						})}
					</table>
				</div>
			</main>

		</>

	)
}

export default PersonsPage